"use client" 
import JobModal from "@/components/Organisms/Modals/JobModal";
import { useEffect, useState } from "react";
// export const metadata = {
//   title: 'Admin Portal - Talentive',
//   description: 'Talentive Administrator Portal',
// }

import AdminSideNavbar from "@/components/Organisms/Nav/AdminSideNavbar";
import SignInCard from "@/components/Organisms/SignInCard";
import Loading from "@/components/Atoms/Alerts/Loading";
import checkSignInStatus from "@/utils/frontend/checkSignInStatus";
// import { ModalProvider } from "@/contexts/ModalContext";
import Sidebar from "@/components/Organisms/Nav/Sidebar";
// import TagsModal from "@/components/Organisms/Modals/TagsModal";
import TalentModal from "@/components/Organisms/Modals/TalentModal";
import AdminSideFilterBar from "@/components/Organisms/Nav/AdminSideFilterBar";
import { getData } from "@/utils/frontend/dataOps";
import Alert from "@/components/Atoms/Alerts/Alert";
// import BulletinModal from "@/components/Organisms/Modals/BulletinModal";

import SpecializationsParentCard from "@/components/Organisms/Cards/SpecializationsParentCard";

import { detectLang } from "@/utils/frontend/langOps";
// import SupportModal from "@/components/Organisms/Modals/SupportModal";
import CandidateWorkspaceSideNavbar from "@/components/Organisms/Nav/CandidateWorkspaceSideNavbar";
import { redirect } from "next/navigation";
import { getCookies } from "@/utils/frontend/cookieOps";
// import AdminSidebar from "@/components/Organisms/Nav/AdminSidebar";

export default function EmployerWorkspaceLayout({ children }) {

     const [lang, setLang] = useState('en')
     const [userIsSignedIn, setUserIsSignedIn] = useState(false)
     const [loading, setLoading] = useState(true)
     const [jobModalOpen, setJobModalOpen] = useState(false)
     const [supportModalOpen, setSupportModalOpen] = useState(false)
     const [tagsModalOpen, setTagsModalOpen] = useState(false)
     const [talentModalOpen, setTalentModalOpen] = useState(false)
     const [bulletinModalOpen, setBulletinModalOpen] = useState(false)
     const [success, setSuccess] = useState(null)
     const [error, setError] = useState(null)
     const [tagsTable, setTagsTable] = useState(null)
     const [userFromCookies, setUserFromCookies] = useState(getCookies()?.user)




  let wndow;
  useEffect(() => {

    const getTags = async () => {
      let response = await getData('tags', 'no-store', undefined, undefined, undefined)
      setTagsTable(response.data)
    }

    const verifyUser = async () => {
        try {
            setUserIsSignedIn(await checkSignInStatus(userFromCookies?.user_type, 'include', undefined, undefined)); // can change to userType to "EMPLOYER" ?
        } catch (error) {
            console.error('Error checking sign-in status:', error);
        } finally {
            setLoading(false);
        }
    };

    verifyUser(); getTags();

    wndow = window
    // setLang(detectLang(wndow.location.pathname))
    
}, [wndow]);



  const handleChildCallback = (callback) => {
    console.log('callback@layout', callback)
    if (callback.jobModalOpen) {setJobModalOpen(callback.jobModalOpen)}
    if (callback.bulletinModalOpen) {setBulletinModalOpen(callback.bulletinModalOpen)}
    if (callback.tagsModalOpen) {setTagsModalOpen(callback.tagsModalOpen)}
    if (callback.talentModalOpen) {setTalentModalOpen(callback.talentModalOpen)}
    if (callback.supportModalOpen) {setSupportModalOpen(callback.supportModalOpen)}
}


  return (

      <div className="mx-2">
        <span>{loading && <Loading/>}</span> 
        {userIsSignedIn ? 
        redirect(`/workspace`)
//           <>
//             <Alert message={success ? success.message : error ? error.message : ''} state={{success: success, setSuccess: setSuccess, error: error, setError: setError}}/>

//             <CandidateWorkspaceSideNavbar lang={lang} callback={handleChildCallback}/>

//             <SupportModal
//             lang={lang}
//               modalHeaderCaption={lang === 'fr' ? 'Demande de Support ou de Fonctionnalité' : 'Request Support or Functionality' }
//               state={{supportModalOpen: supportModalOpen, setSupportModalOpen: setSupportModalOpen, success: success, setSuccess: setSuccess, error: error, setError: setError}}
//               />
// <div className="ml-20">
//        {children}
// </div>
//           </> 
          : 
        <SignInCard parent={'GEN_AUTH'} userType={'RECRUITER'} lang={lang}/>
}
        {/* {children} */}
        </div>
  )
}
